import React, { PureComponent } from "react";
import { changeLocation } from "api/Location";

import { fontFamily, dFlex } from "./styles";
import OnePanel from "./OnePanel";
import Text from "./Text";
import { decimalsRound } from "../../services/utils";

const FEEDBACK_CONTENT = {
  "market leader": (
    <span>
      Bold, fearless, dominant, are a few words that come into mind. Keep
      performing at this high level and maintain your leadership. <b>#Boss</b>!
    </span>
  ),
  "market challenger": (
    <span>
      Great round! You've done a great job in challenging the leader. Next
      round, become the leader. <b>#Soon-to-be-Boss</b>
    </span>
  ),
  "market climber": (
    <span>
      Not bad! Keep climbing until you reach your full potential.{" "}
      <b>#Be-the-Boss</b>
    </span>
  ),
  "market warrior": (
    <span>
      Good battle! You fought the good fight. Now let's go win the war. Become
      the leader! <b>#Be-the-Boss</b>
    </span>
  ),
  "market newbie": (
    <span>
      Young Grasshopper, you have ways to go, but we will help you climb, to
      become a warrior to then challenge the leader. You will be a Master.{" "}
      <b>#Be-the-Boss</b>
    </span>
  )
};

const teamRankMessage = rank_name => {
  const rank_name_key = rank_name.toLowerCase();
  return FEEDBACK_CONTENT[rank_name_key] || "";
};

class TeamReports extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    }, () => {
      setTimeout(() => {
        const { round, isFinished } = this.props;

        if (!isFinished) {
          changeLocation(
            `/analysis/team-reports/financial-statements?round=${round}`
          );
        } else {
          this.setState({
            loading: false,
          });
        }
      }, 500);
    });
  }

  render() {
    const { loading } = this.state;
    const { grades, teamRank, round } = this.props;
    const grade = grades.find(i => i.round_number === round);
    const gradeValue = grade ? grade.current_weighted_value : 0;

    return loading ? <div>Loading...</div> : (
      <OnePanel title="Team reports">
        <div style={dFlex}>
          <div style={{ flex: "2", textAlign: "center" }}>
            <Text>As of this round, your team is the</Text>
            <Text style={{ fontSize: "32px" }}>{teamRank}!</Text>
            <Text>{teamRankMessage(teamRank)}</Text>
          </div>
          <div style={{ flex: "1", textAlign: "center" }}>
            <span style={{ fontFamily, fontSize: "24px" }}>Team grade</span>
            <br />
            <span style={{ fontFamily, fontSize: "60px" }}>
              {decimalsRound(gradeValue * 100, 2)}%
            </span>
          </div>
        </div>
      </OnePanel>
    );
  }
}

export default TeamReports;



// WEBPACK FOOTER //
// ./src/components/analysis/TeamReports.js